import React from "react";

//Component takes in 3 props
//props 1 Icon  pass in React Icon component or any other Component
// Example icon={<FaSitemap size={120} className="NetworkIcon" />}

// props 2 optional the Header Info as string
//Example  HeaderInfo="No Linked Accounts"

//prop3 optional pass SubHeaderInfo as string
//SubHeaderInfo="Members of your network will appear here"

//style object should be in this format to work

//style = { main: {"color":"red"}, header :{...}, subheader: {...}}

const defaultStyles = {
  textAlign: "center",
  paddingTop: "5px",
  paddingBottom: "5px",
  // "height": "450px",
  position: "relative",
  border: "1px solid #e9e9e9",
  borderTop: "0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const defaultHeader = {
  color: "#000000",
  marginBottom: "0",
  fontSize: "17px",
  lineHeight: "26px",
  fontWeight: "400",
  maxWidth: "100%",
};

const defaultSubheader = {
  color: "#000000",
  marginTop: "0",
  fontSize: "13px",
  lineHeight: "17px",
  maxWidth: "100%",
};

const NoDataText = {
  position: "relative",
  textAlign: "center",
};

export default function NoDataComponent(props) {
  const { Main, Header, subheader } = { ...props.NoDataComponentStyle };
  // {console.log(props)}
  return (
    <div style={Main ? Main : defaultStyles} {...props}>
      {props.icon}
      <div style={NoDataText}>
        <p style={Header ? Header : defaultHeader}>
          {props.headerinfo || "No Data Found"}
        </p>
        <p style={subheader ? subheader : defaultSubheader}>
          {" "}
          {props.subheaderinfo || ""}
        </p>
      </div>
    </div>
  );
}
